<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div class="player-game-data">
    <div v-if="thisPlayerId >0" class="main">
      <div class="trigon">
        <div class="main">
          <!-- <span :style="'color:'+$dataManager.findTeam(player.teamId).team.color">自摸率</span> -->
          <!-- <span :style="'color:'+$dataManager.findTeam(player.teamId).team.color">胡牌率</span> -->
          <!-- <span :style="'color:'+$dataManager.findTeam(player.teamId).team.color">放槍率</span> -->
          <multiTrigon
            v-if="isLoading"
            :width="Trigon.width"
            :height="Trigon.width"
            :bgcolor="transparent"
            :cfgs="cfgs"
            :datas="datas"
          />
        </div>
      </div>
      <div class="rows" :style="{color: `#D6FF17`}">
        <div class="item">
          <!-- <div class="title" :style="'background-color:'+$dataManager.findTeam(player.teamId).team.color">出場雀數</div> -->
          <div class="data" v-text="player.data.allGames" />
          <div class="lifedata" v-text="life.allGames" />
        </div>
        <div class="item">
          <!-- <div class="title" :style="'background-color:'+$dataManager.findTeam(player.teamId).team.color">總得分</div> -->
          <div class="data" v-text="player.data.points" />
          <div class="lifedata" v-text="life.points" />
        </div>
        <div class="item">
          <!-- <div class="title" :style="'background-color:'+$dataManager.findTeam(player.teamId).team.color">平均得分</div> -->
          <div class="data" v-text="roundDecimal((player.data.points/player.data.allGames),2)" />
          <div class="lifedata" v-text="roundDecimal((life.points/life.allGames),2)" />
        </div>
        <div class="item">
          <!-- <div class="title" :style="'background-color:'+$dataManager.findTeam(player.teamId).team.color">單把最高</div> -->
          <div class="data" v-text="player.data.maxPoint" />
          <div class="lifedata" v-text="life.maxPoint" />
        </div>
        <div class="item">
          <!-- <div class="title" :style="'background-color:'+$dataManager.findTeam(player.teamId).team.color">自摸數</div> -->
          <div class="data" v-text="player.data.tsumoCount" />
          <div class="lifedata" v-text="life.tsumoCount" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import backgroundImage from '@/assets/playerData/test.png'
import multiTrigon from '@/components/majcmp/multiTrigon'

export default {
  name: 'PlayerGameBaseDataP1',
  components: { multiTrigon },
  data() {
    return {
      // backgroundImage: backgroundImage,
      season: {},
      player: {
        data: {
          tsumoCount: 0,
          winCount: 0,
          loseCount: 0
        }
      },
      Trigon: {
        width: 290,
        height: 810
      },
      players: [],
      isLoading: false,
      transparent: 'rgba(0,0,0,0)',
      liveSetting: {},
      life: {
        tsumoCount: 0,
        winCount: 0,
        loseCount: 0
      },
      thisPlayerId: 0
    }
  },
  computed: {
    title: function() {
      return this.season.name ? this.season.name.indexOf('N') !== -1 ? 'N' : 'S' : ''
    },
    cfgs: function() {
      return {
        'lineLength': this.Trigon.width * 1.33,
        'borderWidth': 4,
        'dotWidth': 8,
        'borderColor': `#D6FF17`, // this.$dataManager.findTeam(this.player.teamId).team.color,
        'delayTime': 0,
        'animationTime': 500,
        'borderCover': true,
        'visMode': '3',
        'maxValueFullRate': 0.7
      }
    },
    datas: function() {
      var fill = 'rgba(255,255,255,.8)'
      var _fill = 'rgba(179,181,182,.6)'
      var data = [{
        'color': `#D6FF17`,
        'fill': fill,
        'rates': [
          this.roundDecimalPercentDraw((this.player.data.tsumoCount / this.player.data.allHands) * 100, 2),
          this.roundDecimalPercentDraw((this.player.data.winCount / this.player.data.allHands) * 100, 2),
          this.roundDecimalPercentDraw((this.player.data.loseCount / this.player.data.allHands) * 100, 2)
        ]
      }, {
        'color': `#D6FF17`,
        'fill': _fill,
        'rates': [
          this.roundDecimalPercentDraw((this.life.tsumoCount / this.life.allHands) * 100, 2),
          this.roundDecimalPercentDraw((this.life.winCount / this.life.allHands) * 100, 2),
          this.roundDecimalPercentDraw((this.life.loseCount / this.life.allHands) * 100, 2)
        ]
      }]
      return data
    }
  },
  mounted() {
    if (!this.$bus._events['liveSetting']) {
      this.$bus.$on('liveSetting', content => {
        this.liveSetting = content
        this.getData()
      })
    }
    if (!this.$bus._events['playerSetting']) {
      this.$bus.$on('playerSetting', content => {
        if (!this.thisPlayerId) {
          this.thisPlayerId = content.gameBase
        } else {
          if (this.thisPlayerId !== content.gameBase) {
            this.thisPlayerId = content.gameBase
            this.getPlayerLifeData(content.gameBase)
          }
        }
      })
    }
    window.addEventListener('keydown', (e) => {
      this.key = e.key
    })
  },
  methods: {
    roundDecimalPercentDraw: function(val, precision) {
      var data = Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0)) || 0
      return data
    },
    roundDecimal: function(val, precision) {
      var data = Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0))
      return data || '-'
    },
    roundDecimalPercent: function(val, precision) {
      var data = Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0)) || '-'
      return (data !== '-') ? data + '%' : data
    },
    getData: function() {
      this.isLoading = false
      this.$store.commit('CLOSE_LOADING')
      this.$store.dispatch('getData', { type: 'Season', credentials: this.liveSetting.seasonId }).then((res) => {
        if (!res.errorCode) {
          this.season = res.data
          this.$store.commit('UPDATE_TEAM', res.data.teams)
          this.$store.dispatch('playerDetailBySeason', { credentials: this.liveSetting.seasonId }).then((res) => {
            if (!res.errorCode) {
              this.players = res.data
              this.players.forEach((p) => {
                if (p.playerId === this.thisPlayerId) {
                  this.player = p
                }
              })
              this.getPlayerLifeData(this.thisPlayerId)
              this.isLoading = true
            }
          })
        }
      })
    },
    getPlayerLifeData: function(id) {
      this.$store.commit('CLOSE_LOADING')
      this.$store.dispatch('playerDetail', { credentials: id }).then((res) => {
        if (!res.errorCode) {
          this.life = res.data
          this.players.forEach((p) => {
            if (p.playerId === id) {
              p.life = res.data
              this.player = p
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../../style/show/playerGameBaseData';

</style>
